import { Box, Grid, Skeleton } from '@mui/material';
import SimpleVideoThumbnail from '../common/SimpleVideoThumbnail';
import { ChildVideo } from '../types/videos';
import ClearIcon from '@mui/icons-material/Clear';

export const ChildVideoItemSkeleton = ({ video }: { video: ChildVideo }) => {
  return <Grid data-uuid={video.uuid} item key={video.uuid} xs={3}>
    <Grid container spacing={1}>
      <Grid item>
        {video.status !== 'errored' && video.thumbnail &&
          <SimpleVideoThumbnail format={video.format} imageUrl={video.thumbnail} />}
        {video.status !== 'errored' && !video.thumbnail &&
          <Skeleton variant="rounded" width={video.format === 'horizontal' ? 250 : 90} height={160}/>}
        {video.status === 'errored' && !video.thumbnail && <Box width={250} height={140} sx={{
          bgcolor: 'red',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '5%'
        }}>
          <ClearIcon/>
        </Box>}
      </Grid>
      <Grid item>
        <Skeleton variant="circular" width={40} height={40}/>
      </Grid>
    </Grid>
    <Skeleton variant="text" sx={{ fontSize: '1rem' }}/>
    <Skeleton variant="text" sx={{ fontSize: '0.8rem' }}/>
    <Skeleton variant="text" sx={{ fontSize: '0.8rem' }}/>
  </Grid>;
};